/*! © 2026 AirX (airx.art). All rights reserved. Unauthorized copying, reproduction, or redistribution of this code is prohibited. Report infringement: info@airx.art */

(function () {
  'use strict';

  if (customElements.get('product-recommendations')) return;

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      this.url = this.dataset.url;
      this.container = this.querySelector('[data-recommendations]');
      if (!this.container) return;

      if (this.container.querySelector('.product-card')) return;

      if (!this.url) {
        this.collapse();
        return;
      }

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries[0].isIntersecting) return;
            this.observer.disconnect();
            this.observer = null;
            this.load();
          },
          { rootMargin: '480px 0px' }
        );
        this.observer.observe(this);
      } else {
        this.load();
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    async load() {
      try {
        const res = await fetch(this.url);
        if (!res.ok) throw new Error('Recommendations request failed');
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const fresh = doc.querySelector('[data-recommendations]');

        if (fresh && fresh.querySelector('.product-card')) {
          this.container.innerHTML = fresh.innerHTML;
          this.container.removeAttribute('aria-busy');
          if (window.AirX) window.AirX.emit('motion:scan', { root: this });
        } else {
          this.collapse();
        }
      } catch (err) {
        this.collapse();
      }
    }

    collapse() {
      const wrap = this.querySelector('[data-recommendations-wrap]');
      if (wrap) wrap.hidden = true;
      const chips = this.querySelector('[data-mood-chips]');
      if (chips) return;
      const header = this.querySelector('[data-recommendations-header]');
      if (header) header.hidden = true;
      const section = this.closest('.product-recommendations');
      if (section) section.hidden = true;
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
})();
